// AB test: PLP info card. Markup comes from snippets/plp-info-card.liquid and stays
// display:none in assets/plp-info-card.css until body.plp-info-card-test is set.
//
// QA override: pins the variant on for review. MUST go back to false before this ships:
// while it is true the feature flag and the holdout are both ignored, so there is no
// control group and the test measures nothing.
const FORCE_PLP_INFO_CARD_TEST = false;

function setupPlpInfoCard() {
    try {
        const FLAG = 'rajani-plp-info-card';
        const HOLDOUT_FLAG = 'holdout-pdm-rajani-q3-2026';
        const HOLDOUT_VALUE = 'rajani-holdout-q3-2026';
        const BODY_CLASS = 'plp-info-card-test';

        const applyFeatureFlags = () => {
            // this script is async in <head>, so GrowthBook can flush its queue before <body> exists
            if (!document.body) {
                document.addEventListener('DOMContentLoaded', applyFeatureFlags, { once: true });
                return;
            }

            const gb = window._growthbook;
            const value = gb?.getFeatureValue(FLAG, false);
            const holdout = gb?.getFeatureValue(HOLDOUT_FLAG, 'exposed');

            // holdout users always get control, whatever the test flag says
            const isOn = FORCE_PLP_INFO_CARD_TEST || (value === true && holdout !== HOLDOUT_VALUE);
            document.body.classList.toggle(BODY_CLASS, isOn);
        };

        // QA only: keep the variant visible even if GrowthBook never loads
        if (FORCE_PLP_INFO_CARD_TEST) {
            applyFeatureFlags();
        }

        window.growthbook_queue = window.growthbook_queue || [];
        window.growthbook_queue.push(_ => {
            applyFeatureFlags();
            document.addEventListener('growthbookdata', applyFeatureFlags);
        });
    } catch (error) {
        console.error('Error setting up PLP info card test:', error);
    }
}

setupPlpInfoCard();

function setupHamburgerMenuTest() {
    try {

        const FLAG = 'rajani-hamburger-menu';
        const HOLDOUT_FLAG = 'holdout-pdm-rajani-q3-2026';
        const HOLDOUT_VALUE = 'rajani-holdout-q3-2026';
        const BODY_CLASS = 'hamburger-menu-test';

        // Floating widgets (Gorgias chat, accessiBe) overlap the mobile menu, so hide them while the menu drawer is open
        const floatingWidgetsStyle = document.createElement('style');
        floatingWidgetsStyle.textContent = `
            body:has(#mobile-menu-drawer[open], mobile-navigation-test[open]) :is(.gorgias-chat-key-1vly0ou, .acsb-trigger) {
                display: none !important;
            }
        `;
        document.head.appendChild(floatingWidgetsStyle);

        const applyFeatureFlags = () => {
            // this script is async in <head>, so GrowthBook can flush its queue before <body> exists
            if (!document.body) {
                document.addEventListener('DOMContentLoaded', applyFeatureFlags, { once: true });
                return;
            }

            const gb = window._growthbook;
            const value = gb?.getFeatureValue(FLAG, false);
            const holdout = gb?.getFeatureValue(HOLDOUT_FLAG, 'exposed');

            // holdout users always get the default mobile menu, whatever the test flag says
            const isOn = value === true && holdout !== HOLDOUT_VALUE;
            document.body.classList.toggle(BODY_CLASS, isOn);
        };

        window.growthbook_queue = window.growthbook_queue || [];
        window.growthbook_queue.push(_ => {
            applyFeatureFlags();
            document.addEventListener('growthbookdata', applyFeatureFlags);
        });
    } catch (error) {
        console.error('Error setting up hamburger menu test:', error);
    }
}

setupHamburgerMenuTest();
